import m from "mithril";
export default class {
    view() {
        return (m("article", { class: "offline-overlay" },
            m("div", { class: "alert alert--danger alert--icon" },
                m("i", { class: "fas fa-exclamation-triangle" }),
                m("span", null, "Sie haben zurzeit keine Verbindung zum Internet. Unser Dienst ist solange nur eingeschr\u00E4nkt nutzbar."))));
    }
}
